import React from 'react';
import CountUp from '@/components/landing/common/CountUp'
import styled from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints'

const StyledComp = styled.div`
  padding: 0px 40px;
  width: calc(100% - 80px);
  background-color: white;
  position: relative;
  z-index: 9;


  .stats-section {
    padding-top: 80px;
    padding-bottom: 80px;
  }

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 60px;
  }

  .stat-item {
    border-left: 1px solid var(--grey);
    padding-left: 30px;
    display: flex;
    flex-direction: column;
  }

  .stat-number {
    font-size: 72px;
    font-weight: 300;
    line-height: 1;
    margin-bottom: 16px;

    @media (max-width: ${breakpoints.small}) { 
      font-size: 45px;
    }
  }

  .stat-description {
    font-size: 14px;
    line-height: 1.6;
    color: #666;
    min-height: 75px;
  }

  .stat-company {
    font-size: 13px;
    color: #666;
    margin-top: 12px;
  }

  @media (max-width: 768px) {
    .grid {
      grid-template-columns: 1fr;
    }

    .stats-grid {
      grid-template-columns: 1fr;
    }
  }
`;

const Comp = ({}) => {
  return (
    <StyledComp>
      <div className="container">

        <div className="stats-section">

          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">
                <CountUp from={0}
                  to={2}
                  separator=","
                  direction="up"
                  duration={1}
                  className="count-up-text"
                />
                PB
              </div>
              <div className="stat-description">Alternative datasets processed and queryable Cross-asset coverage, normalized and ready for model ingestion </div>
              <div className="stat-company">Structured Data</div>
            </div>

            <div className="stat-item">
              <div className="stat-number">
                <CountUp from={0}
                  to={14}
                  separator=","
                  direction="up"
                  duration={1}
                  className="count-up-text"
                />

                B</div>
              <div className="stat-description">New records added in the last 18 months. Continuously expanding global signal coverage </div>
              <div className="stat-company">Rows of Data</div>
            </div>

            <div className="stat-item">
              <div className="stat-number">~
                <CountUp from={0}
                  to={44}
                  separator=","
                  direction="up"
                  duration={1}
                  className="count-up-text"
                />
                M</div>
              <div className="stat-description">Daily and hourly delivery into research and production pipelines </div>
              <div className="stat-company">Daily Requests</div>
            </div>

            <div className="stat-item">
              <div className="stat-number">
                <CountUp from={0}
                  to={10}
                  separator=","
                  direction="up"
                  duration={1}
                  className="count-up-text"
                />
                x</div>
              <div className="stat-description">Faster signal discovery vs legacy providers. Pre-cleaned, schema-consistent, backtest-ready</div>
              <div className="stat-company">Research Velocity</div>
            </div>

            <div className="stat-item">
              <div className="stat-number">
                <CountUp from={0}
                  to={3}
                  separator=","
                  direction="up"
                  duration={1}
                  className="count-up-text"
                />
                M</div>
              <div className="stat-description">Institutional-grade events tracked across entities Corporate actions, filings, web traffic, geospatial, alt feeds </div>
              <div className="stat-company">Event Intelligence</div>
            </div>

            <div className="stat-item">
              <div className="stat-number"><CountUp from={0}
                  to={99.999}
                  separator=","
                  direction="up"
                  duration={0.1}
                className="count-up-text"
              />
                %</div>
              <div className="stat-description">Redundant ingestion, continuous monitoring, enterprise SLAs </div>
              <div className="stat-company">Uptime</div>
            </div>
          </div>
        </div>
      </div>
    </StyledComp>
  );
};

export default Comp;
